import csvValue from "./csvValue.js";


function dataToCsv(data, negatives, structures){
let res = "Enzyme_marts_ID,Uniprot_ID,Genbank_ID,Enzyme_name,Aminoacid_sequence,Species,Kingdom,Type,Class,Substrate_name,Substrate_smiles,Substrate_chebi_ID,Substrate_marts_ID,Substrate_stereochemistry,Product_name,Product_smiles,Product_chebi_ID,Product_marts_ID,Product_stereochemistry,Reaction_has_mechanism,Mechanism_marts_ID,Publication,Publication_doi,Product_yield,Major_substrate,Experiment_conditions,Negative_substrates,available_structures\n"
// Firt sort data
let sortedData = data.sort((a, b) => {
    if (a.enzyme_pers_id < b.enzyme_pers_id) return -1;
    if (a.enzyme_pers_id > b.enzyme_pers_id) return 1;
    // Sort also by reaction_enzyme_pair_id
    if (a.reaction_enzyme_pair_id < b.reaction_enzyme_pair_id) return -1;
    if (a.reaction_enzyme_pair_id > b.reaction_enzyme_pair_id) return 1;
    return 0;
});
let negativeDict = {};
if (negatives){
    negativeDict = {};
    negatives.forEach((neg) => {
        if (!negativeDict[neg.enzyme_marts]){
            negativeDict[neg.enzyme_marts] = [];
        }
        negativeDict[neg.enzyme_marts].push(neg.marts);
    }); 
}
// enzyme MARTS ID -> ";"-joined list of structure determination methods, from
// the `structures` payload of /download. Enzymes without a structure are absent.
let structureDict = {};
if (structures){
    structures.forEach((str) => {
        structureDict[str.enzyme_marts] = str.methods || "";
    });
}
sortedData.forEach((element) => {
    let has_mechanism = (element.mechanism_id != null);
    let mechanism_marts_id = has_mechanism ? element.mechanism_pers_id : "no_mechanism";
    const names = [];
    const smiles = [];
    const chebis = [];
    const persIds = [];
    const stereos = [];
    
    (element.substrates || []).forEach(cosubs => {
      names.push(cosubs.name);
      smiles.push(cosubs.smiles);
      chebis.push(cosubs.chebi);
      persIds.push(cosubs.marts);
      stereos.push(cosubs.stereochemistry);
    });

    let negatives = ""
    if (negativeDict && negativeDict[element.enzyme_pers_id]){
        negatives = negativeDict[element.enzyme_pers_id].join(";");
    }

    const available_structures = structureDict[element.enzyme_pers_id] || "";
    
    const substrate_name = names.join(";");
    const substrate_smiles = smiles.join(";");
    const substrate_chebi = chebis.join(";");
    const substrate_stereochemistry = stereos.join(";");
    const substrate_pers_id = persIds.join(";");
    let new_line = `"${csvValue(element.enzyme_pers_id)}","${csvValue(element.uniprot_id)}","${csvValue(element.genbank_id)}","${csvValue(element.name)}","${csvValue(element.aminoacid_sequence)}","${csvValue(element.species)}","${csvValue(element.kingdom)}","${csvValue(element.type)}","${csvValue(element.class)}","${substrate_name}","${substrate_smiles}","${substrate_chebi}","${substrate_pers_id}","${substrate_stereochemistry}","${csvValue(element.product_name)}","${csvValue(element.product_smiles)}","${csvValue(element.product_chebi)}","${csvValue(element.product_pers_id)}","${csvValue(element.product_stereochemistry)}",${has_mechanism},${mechanism_marts_id},"${csvValue(element.reaction_link)}","${csvValue(element.reaction_doi)}","${csvValue(element.product_yield)}","${csvValue(element.major_substrate)}","${csvValue(element.condition_tags)}","${negatives}","${available_structures}"\n`
    res = res + new_line
}); 
return res
} 



function submissionToCsv(data){
    let res = Object.keys(data[0]).join(",") + "\n";
    data.forEach((row) => {
        let new_line = Object.values(row).map(value => `"${csvValue(value)}"`).join(",") + "\n";
        res += new_line;
    });
    return res;
}

export default dataToCsv

export { submissionToCsv };